import { usePersonData } from '~domains/profile/entities/person';

import { convertISOToPhDate } from '~shared/lib/convert-date';
import { InfoCard, InfoCardSkeleton } from '~shared/ui/info-card';
import { InfoField } from '~shared/ui/info-field';

import { Typography } from '@breezeventures/ui-kit/typography';

const BASIC_INFO_FIELDS_COUNT = 5;

export const PersonBasicInfoCard = () => {
  const { data, isLoading, isError } = usePersonData();

  if (data) {
    const birthDate = data.birthDate
      ? convertISOToPhDate(data.birthDate)
      : undefined;

    return (
      <InfoCard header="Basic info">
        <div className="grid grid-cols-2 gap-4">
          <InfoField title="First name" value={data.firstName} />
          <InfoField title="Middle name" value={data.middleName} />
          <InfoField title="Last name" value={data.lastName} />
          <InfoField title="Date of birth" value={birthDate} />
          <InfoField title="E-mail" value={data.email} />
        </div>
      </InfoCard>
    );
  }

  if (isLoading) {
    return <InfoCardSkeleton rows={BASIC_INFO_FIELDS_COUNT} />;
  }

  if (isError) {
    return (
      <Typography.Text size="s" color="negative">
        Failed to load profile data
      </Typography.Text>
    );
  }

  return null;
};
